var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-preview"},[_c('img',{staticClass:"phone-image",attrs:{"src":_vm.imageUrl,"alt":_vm.imageAlt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }